import React from "react";
import styled, { css } from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";

const JunoDetails = styled.details`
  display: block;
  clear: both;
  margin-bottom: 1rem;
  ${mediaQueries.md} {
    margin-bottom: 1.75rem;
  }
  max-width: 38rem;
`;

const JunoDetailsSummary = styled.summary`
  display: list-item;
  width: fit-content;

  font-size: var(--juno-font-size-body-sm);
  line-height: normal;
  ${mediaQueries.md} {
    font-size: var(--juno-font-size-body-md);
  }
  color: var(--juno-color-link);
  cursor: pointer;

  &:hover {
    color: var(--juno-color-link-hover);
  }

  &:focus-visible {
    outline: var(--juno-focus-outline-width) solid var(--juno-color-focus);
    outline-offset: var(--juno-focus-outline-offset);
  }

  ${(props) =>
    props.boldSummary &&
    css`
      font-weight: var(--juno-font-weight-bold);
    `}
`;

const JunoDetailsText = styled.div`
  margin-top: 0.5em;
`;

function Details(props) {
  return (
    <JunoDetails className={props.className}>
      <JunoDetailsSummary boldSummary={props.boldSummary}>{props.summary}</JunoDetailsSummary>
      <JunoDetailsText>{props.children}</JunoDetailsText>
    </JunoDetails>
  );
}

export default Details;
